import { useEffect, useState } from 'react';

import { useAlert } from 'common/hooks';
import { IPageResult, IProject } from 'common/models';

import { ProjectManagementServices } from 'admin/services';

export const useProjects = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [queryOptions, setQueryOptions] = useState({});
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 15,
  });
  const [projectsResults, setProjectsResults] = useState<IPageResult<IProject>>(
    {
      data: [],
      total: 0,
    }
  );

  const { onAlert } = useAlert();

  useEffect(() => {
    const queryParams = new URLSearchParams({
      page: (paginationModel.page + 1).toString(),
      pageSize: paginationModel.pageSize.toString(),
      ...queryOptions,
    });
    setIsLoading(true);
    ProjectManagementServices.getProjects(queryParams.toString())
      .then((res) => setProjectsResults(res))
      .catch((err) => {
        onAlert('Failed to fetch projects', 'error');
        console.error(err);
      })
      .finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationModel.page, paginationModel.pageSize, queryOptions]); // TO DO use react query

  return {
    isLoadingProjects: isLoading,
    paginationModel,
    projectsResults,
    setPaginationModel,
    setQueryOptions,
  };
};
